import { bl_fi_internal_sales_quotation_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class SalesQuotationFileImportContainerModel extends BaseContainerModel {
    bl_fi_internal_sales_quotation_import_file_hdr: bl_fi_internal_sales_quotation_import_file_hdr_RowClass = new bl_fi_internal_sales_quotation_import_file_hdr_RowClass();
}